import React from 'react';
import Accordion from '~/components/Accordion';
import Text from '~/components/Text';
import Divider from '~/components/Divider';
import SummaryItem from '~/components/Items/SummaryItem';
import { formatNumber } from '~/utils/number';
import { Order } from '~/services/order';
import Colors from '~/constants/colors';

type Props = {
    order: Partial<Order>;
};

const OrderReview = ({ order }: Props) => {
    const subtotal =
        order?.items
            ?.map((item) => {
                const finalPrice = item.selectedVariant?.product?.price_range?.minimum_price?.final_price?.value || 0;
                const quantity = item.quantity || 1;

                return finalPrice * quantity;
            })
            .reduce((sum, item) => sum + item, 0) || 0;

    const shipping_fee = order?.shipping_fee || 0;

    const discount = order?.prices?.discounts?.reduce((total, item) => total + item.amount.value, 0) || 0;

    const total = subtotal + shipping_fee - discount;

    return (
        <div>
            <Accordion
                variant="filled"
                className="w-full lg:hidden border border-grey-100 rounded-lg"
                defaultActive={['order-review']}
                items={[
                    {
                        label: <Text type="title-2">Order Review</Text>,
                        key: 'order-review',
                        content: (
                            <div className="flex flex-col gap-5">
                                {order?.items?.map((item: any) => (
                                    <SummaryItem key={item.id} cartItem={item} />
                                ))}
                                <Divider dividerClassName="border-dashed" />
                                <div className="flex items-center justify-between gap-6">
                                    <Text type="label-4">Subtotal</Text>
                                    <Text type="body-3">${formatNumber(subtotal, 2) || 0}</Text>
                                </div>
                                <div className="flex items-center justify-between gap-6">
                                    <Text type="label-4">Shipping</Text>
                                    <Text type="body-3" className="text-grey-300">
                                        ${formatNumber(order?.shipping_fee || 0, 2)}
                                    </Text>
                                </div>
                                <div className="flex flex-col gap-3">
                                    <div className="flex items-center justify-between gap-6">
                                        <Text type="label-4">Discount</Text>
                                        <Text type="body-3" color={Colors.ACCENT_RED}>
                                            -${formatNumber(discount || 0, 2)}
                                        </Text>
                                    </div>
                                </div>
                                <Divider />
                                <div className="flex flex-col gap-3">
                                    <div className="flex items-center justify-between gap-6">
                                        <Text type="label-3">Total</Text>
                                        <Text type="title-4" className="text-primary">
                                            ${formatNumber(total, 2) || 0}
                                        </Text>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                ]}
            />
        </div>
    );
};

export default OrderReview;
